export interface ModalConfig {
  buttons?: Array<ModalButton>;
  heading: string;
  modalContent?: string ;
  align?: any;
  hasTemplate?: any;
  hasDropdown?: boolean;
  dropdownLabel?: string;
  dropdownOptions?: Array<{ label: string, value: any }>;
  dynamicContent?: boolean;
  baseContent?: string;
  selectedUserPlaceholder?: string;
  scrollable?: boolean;
  hideCloseIcon?: boolean;
  showLogo?: boolean;
  logoSrc?: string;
  confirmContent?: Array<{ label:string, value:any}>;
  modalContentClass?: string;
  modalInputArray? : Array<{ label:string, fieldName: string, value?: any, type:any , placeholder?: string,tooltip?: string,error?:string, content?:string}>;
  modalContentArray?: Array<{ content: string | any , contentClass?: string, isSafeHtml?: boolean }>;
  isDangerButton?: boolean;
  panelClass?: string;
  /** When set, use with panelClass styles (e.g. left title + close). Omit for centered heading (default). */
  headingAlign?: 'left' | 'center';
}
export interface ModalButton {
  text: string;
  code?: any;
  btnOutline?: any;
  navigate?: string;
}

export const modalHeading = Object.freeze({
  assignApp: "Assign Application",
  unassignApp: "Unassign Application",
  assignComplaint: "Assign Complaint",
  unassignComplaint: "Unassign Complaint",
  viewLockedComplaint: "Complaint Locked",
  assignedComplaint: "Complaint Assigned",
  viewLockedAp: "Application Locked",
  AssignApplication: "Application Assigned",
  applicationAlreadySubmitted: "Application Already Submitted",
  legacyUser: "Profile Update Required",
  tnc:" Terms and Conditions",
  useragreementfp: "Fingerprinting User Agreement",
  useragreement: "LEA User Agreement",
  useragreementepp: "EPP User Agreement",
  privacyPolicy:" Privacy Policy",
  activateExam: "Activate Exam",
  deactivateExam: "Deactivate Exam",
  confirmSubmission: "Confirm Submission",
  accountMayExist:"Account May Already Exist",
  viewMessageCenter: 'View Email',
  extendLicense: "Extend License",  
  confirmStatus :'Confirm Status Update',
  reverseExtn:`Reverse Extension`,
  activityDetails : 'View Change',
  /** Staff document upload first step (lookup tabs) */
  staffDocumentUploadNotice: 'Document Upload Notice',
  /** Same flow as notice; used by Activities supporting-doc upload only */
  staffDocumentUploadWarning: 'Upload Warning',
  /** Educator profile: duplicate file detected before upload */
  educatorDuplicateDocumentDetected: 'Duplicate Document Detected',
  unarchiveApplication: 'Unarchive Application'
});
export const modalContent = Object.freeze({
  unArchiveApplication: `<p class="mb-3">Unarchiving will make this application active. Its queue will be determined by its current application status, and its archival date will be recalculated based on the current date.</p> <p>Do you want to proceed?</p>`,
  assignAppToYourself: `<p class="mb-3">You are about to assign this application to yourself. It is currently unassigned, so it will be locked for your use once assigned.</p> <p>Do you want to continue?</p>`,
  assignAppToStaffMember: (selectedStaffMember?: string) =>
    selectedStaffMember
      ? `<p class="mb-3">You are about to assign this application to <strong>${selectedStaffMember}</strong>. Once assigned, the application will be locked for their use.</p> <p>Do you want to continue?</p>` : `<p class="mb-3">You are about to assign this application to <strong></strong>. Once assigned, the application will be locked for their use.</p> <p>Do you want to continue?</p>`,
  unassignApp: `<p class="mb-3">You are about to unassign this application. If you are the current assignee, it will be released for others. If you are not the assignee, please notify them before proceeding.</p>`,
  viewLockedApp: (firstName: string) => `This application is currently being worked on by <strong>${firstName}</strong>. You can view it, but updates cannot be made at this time. For immediate access, please contact the staff member working on it.`,
  tempLockApp: (fullName: string) => `This application is currently assigned to <strong>${fullName}</strong>. You may view it, but if you need to work on it, you must unassign it in the queue. Please let the assigned staff member know before doing so.`,
  legacyUserFirstLogin: `<p>Welcome to the updated Nevada Online Portal for Application and Licensure (OPAL).
To access applications, renewals, and other licensure services, you must first complete your profile with the required information.</p>`,
  legacyUserGeneral: `<p>You must complete your profile before you can access applications, renewals, or other licensure services. Please update your profile to continue.</p>`,
  statusInvalid: `Are you sure you want to update the Complaint Status to <strong>Invalid</strong>? This action will archive the case and no further action will be required.`,
  statusAssigned:(value:string) => `Are you sure you want to update Complaint Status to <strong>${value}</strong>?`,
  archivalStatus:(value:string) => `Are you sure you want to update the complaint's Archival Status to <strong>${value}</strong>?`,
  unAssignComplaint: `<p class="mb-0">You are about to unassign this complaint. If you are the current assignee, it will be released for others. If you are not the assignee, please notify them before proceeding.</p>`,
  assignComplaint:`<p class="mb-3">You are about to assign this Complaint to yourself. It is currently unassigned, so it will be locked for your use once assigned.</p> <p>Do you want to continue?</p>`,
  assignComplaintToStaffMember: (selectedStaffMember?: string) =>
    selectedStaffMember
      ? `<p class="mb-3">You are about to assign this complaint to <strong>${selectedStaffMember}</strong>. Once assigned, the complaint will be locked for their use.</p> <p>Do you want to continue?</p>` : `<p class="mb-3">You are about to assign this complaint to <strong></strong>. Once assigned, the complaint will be locked for their use.</p> <p>Do you want to continue?</p>`,
  assignedComplaint: (fullName: string) => `This complaint is currently assigned to <strong>${fullName}</strong>. You may view it, but if you need to work on it, you must unassign it in the queue. Please let the assigned staff member know before doing so.`,
  viewLockedComplaint: (fullName: string) => `This Complaint is currently being worked on by <strong>${fullName}</strong>. You can view it, but updates cannot be made at this time. For immediate access, please contact the staff member working on it.`,
  viewEmail(subject: string) {
    return `
      <p class='mb-0'><strong>Subject:</strong></p>
      <p class='mb-3'>${subject}</p>
    `;
  },

  viewEmail1(recipientName: string) {
    return `
      <p class='mb-3'><strong>Dear:</strong> ${recipientName}</p>
      <p class='mb-3'>Thank you for registering with the Nevada Department of Education Online Portal for Application and Licensure.</p>
      <p class='mb-0'>To complete your registration, please click the link below and follow the prompts. This link will remain valid for 24 hours from the time this email was sent.</p>
    `;
  },

  viewEmail2() {
    return `<p class='mb-3'>Regards:Nevada Department of Education</p>`;
  },

  viewMessageCenter(subject: string, recipientName: string) {
    return `
      <div class="modal-email-message">
        <h5 class="mb-3">${modalHeading.viewMessageCenter}</h5>
        ${this.viewEmail(subject)}
        ${this.viewEmail1(recipientName)}
        ${this.viewEmail2()}
      </div>
    `;
  },

  
  tnc: `
    <div class="terms-and-conditions-content document-scroll-container">
      <div class="p-4 text-justify">
        <h5 class="mb-3 text-center"><strong>Nevada Department of Education Online Portal for Application and Licensure System</strong></h5>
        <p class="text-center"><strong>Last Updated:</strong> September 30, 2025</p>
        <ol class="terms-list text-justify">
          <li class="mt-3 document-list-header"><strong>Acceptance of Terms</strong><br>
            <div class="mt-2 document-list-content">By creating an account and using the Nevada Department of Education (NV DOE) Online Portal for Application and Licensure System (the Portal), you agree to be bound by these Terms and Conditions and the NV DOE Privacy Policy, as updated from time to time. If you do not agree, you must not register for or use the Portal.</div>
          </li>
          <li class="mt-3 document-list-header"><strong>Definitions</strong><br>
            <div class="mt-2 pl-3 document-list-content">For the purposes of these Terms and Conditions:</div>
            <ul class="mt-2 pl-3 document-sublist">
              <li class="document-sublist-item"><b>"Portal"</b> means the Nevada Department of Education Online Portal for Application and Licensure System online platform.</li>
              <li class="document-sublist-item"><b>"User"</b> or <b>"You"</b> means any individual who registers for or uses the Portal.</li>
              <li class="document-sublist-item"><b>"NV DOE," "we," "us," or "our"</b> refers to the Nevada Department of Education.</li>
              <li class="document-sublist-item"><b>"Services"</b> means any features, content, or functionality provided through the Portal.</li>
            </ul>
          </li>
          <li class="mt-3 document-list-header"><strong>Purpose of the Portal</strong><br>
            <div class="mt-2 document-list-content">The Portal is provided for the purpose of managing educator licensure applications, renewals, and related communications with NV DOE.</div>
          </li>
          <li class="mt-3 document-list-header"><strong>User Responsibilities</strong>
            <ul class="mt-2 pl-3 document-sublist">
              <li class="document-sublist-item">You agree to provide accurate, current, and complete information during registration and throughout your use of the Portal.</li>
              <li class="document-sublist-item">You agree to use the Portal in compliance with all applicable laws and regulations, and not for any unlawful or prohibited purposes.</li>
              <li class="document-sublist-item">You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account.</li>
              <li class="document-sublist-item">You must notify NV DOE immediately if you suspect unauthorized access to your account.</li>
             <li class="document-sublist-item">When completing applications through the Portal, you are required to type your first and last name exactly as currently approved on record with NV DOE. By doing so, you agree that this constitutes your electronic signature, which is legally binding under ESIGN and UETA.</li>
            </ul>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Confidentiality</strong><br>
            <div class="mt-2" style="font-weight: normal;">By using the Portal, you agree to maintain the confidentiality of any information related to the services, products, materials, and technical documentation you access through the Portal. You shall not disclose or transfer such information to any third party or use it for any unauthorized purpose. You may not use the Portal or its products in violation of any applicable laws, including copyright laws.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Data Collection and Protection</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE collects and processes personal and technical information in accordance with applicable laws and its Privacy Policy to protect users and ensure proper operation of the Portal. This includes data you provide directly (such as name, contact details, education history) and technical information collected automatically (such as device type, browser, IP address, login timestamps).</div>
            <div class="mt-2" style="font-weight: normal;">This data is used solely for security and operational purposes and is not shared with third parties except as required by law.</div>
            <div class="mt-2" style="font-weight: normal;">You agree to comply with all applicable data usage and protection laws and to ensure that any data you access or handle is used only as authorized and protected against unauthorized access or misuse.</div>
            <div class="mt-2" style="font-weight: normal;">NV DOE is committed to processing data fairly, lawfully, and transparently; collecting only what is necessary; keeping data accurate and up to date; retaining data no longer than necessary; and ensuring appropriate security measures are in place.</div>
            <div class="mt-2" style="font-weight: normal;">Further details on data collection, use, and protection are provided in the NV DOE Privacy Policy.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Communication Consent</strong><br>
            <div class="mt-2" style="font-weight: normal;">By agreeing to these Terms, you consent to receive emails, SMS text messages, and other electronic communications from NV DOE for purposes including, but not limited to: account verification, security notifications, official updates regarding your licensure status, system alerts, and legal notices.</div>
            <div class="mt-2" style="font-weight: normal;">Some communications that are legally or operationally required for your account cannot be opted out of. You may manage your communication preferences through your account settings, except for mandatory notifications. Standard message and data rates from your mobile carrier may apply.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Privacy Policy</strong><br>
            <div class="mt-2" style="font-weight: normal;">The NV DOE Privacy Policy forms part of these Terms and explains how your personal data is collected, used, and protected. By agreeing to these Terms, you also agree to the Privacy Policy.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Disclaimer of Warranties and Limitation of Liability</strong><br>
            <div class="mt-2" style="font-weight: normal;">The Nevada Department of Education strives to provide a reliable and secure Online Portal for Application and Licensure System. However, the system and related services are provided on an "as is" and "as available" basis. NV DOE does not guarantee that the system will be uninterrupted, error-free, or free from security issues. While we work to ensure accuracy, we do not warrant or guarantee that results obtained through the system will always be completely accurate or reliable.</div>
            <div class="mt-2" style="font-weight: normal;">NV DOE may update, suspend, or discontinue the system or any part of it at any time without prior notice. Your use of the system is at your own risk.</div>
            <div class="mt-2" style="font-weight: normal;">To the fullest extent permitted by law, NV DOE, its officers, employees, and agents shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of or inability to use the system, even if advised of the possibility of such damages. This includes, but is not limited to, damages for loss of data, loss of business, or loss of goodwill.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Account Suspension</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE reserves the right to suspend or terminate your account and access to the Portal if you violate these Terms and Conditions or for any conduct deemed inappropriate or unlawful.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Intellectual Property</strong><br>
            <div class="mt-2" style="font-weight: normal;">All content, trademarks, logos, software, and materials provided through the Portal are the property of NV DOE or its licensors and are protected by applicable intellectual property laws. Users may not use such content except as authorized.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>No Waiver and Severability</strong><br>
            <div class="mt-2" style="font-weight: normal;">If any provision of these Terms and Conditions is determined to be unlawful, void, or unenforceable, such provision shall nonetheless be enforced to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed severed from these Terms and Conditions. Such determination shall not affect the validity and enforceability of any other remaining provisions. Where possible, the unenforceable provision will be replaced by a valid provision that most closely reflects the original intent of the provision.</div>
            <div class="mt-2" style="font-weight: normal;">Failure by NV DOE to enforce any provision of these Terms shall not be deemed a waiver of future enforcement of that or any other provision. Any waiver must be in writing and signed by an authorized NV DOE representative.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Governing Law</strong><br>
            <div class="mt-2" style="font-weight: normal;">These Terms and Conditions shall be governed by and construed in accordance with the laws of the State of Nevada and applicable federal laws of the United States, without regard to its conflict of law principles.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Dispute Resolution</strong><br>
            <div class="mt-2" style="font-weight: normal;">Any disputes arising from or related to these Terms and Conditions or your use of the Portal shall be resolved under the laws of the State of Nevada. You agree to submit to the exclusive jurisdiction of the state and federal courts located within Nevada.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Third-Party Links and Services</strong><br>
            <div class="mt-2" style="font-weight: normal;">The Portal may contain links to third-party websites or use third-party services. NV DOE does not control, endorse, or assume responsibility for the content, privacy policies, or practices of any third parties. Your use of third-party websites and services is at your own risk.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Entire Agreement</strong><br>
            <div class="mt-2" style="font-weight: normal;">These Terms and Conditions, together with the NV DOE Privacy Policy, constitute the entire agreement between you and NV DOE regarding your use of the Portal and supersede any prior agreements or understandings.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Changes to Terms and Conditions</strong><br>
            <div class="mt-2" style="font-weight: normal;">The Nevada Department of Education reserves the right to modify or update these Terms and Conditions at any time. When changes are made, we will update the "Last Updated" date at the top of this document and may notify you through the Portal or other means for significant changes.</div>
            <div class="mt-2" style="font-weight: normal;">By continuing to access or use the Online Portal for Application and Licensure System after any revisions become effective, you agree to be bound by the revised Terms and Conditions. If you do not agree to the new terms, you are no longer authorized to use the system.</div>
            <div class="mt-2" style="font-weight: normal;">It is your responsibility to review these Terms periodically.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Contact Information</strong><br>
            <div class="mt-2" style="font-weight: normal;">For questions about these Terms and Conditions or support related to the Portal, please contact:<br>
            Nevada Department of Education<br>
            Las Vegas Office<br>
            2080 E. Flamingo Road<br>
            Las Vegas, NV 89119<br>
            P 702.486.6458</div>
          </li>
        </ol>
      </div>
    </div>
  `,

  privacyPolicy: `
    <div class="privacy-policy-content document-scroll-container">
      <div class="p-4 text-justify">
        <h5 class="mb-3 text-center"><strong>Nevada Department of Education Online Portal for Application and Licensure System</strong></h5>
        <p class="text-center"><strong>Last Updated</strong>: September 30, 2025</p>
        <ol class="terms-list text-justify">
          <li class="mt-3 document-list-header"><strong>Introduction</strong><br>
            <div class="mt-2 document-list-content">The Nevada Department of Education operates the Online Portal for Application and Licensure System (the Portal). This Privacy Policy explains how NV DOE collects, uses, discloses, and protects personal information submitted to or collected through the Portal. This policy applies only to information collected via the Portal. By creating an account or using the Portal, you agree to the practices described in this Privacy Policy and the Terms and Conditions.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Information We Collect</strong><br>
            <div class="mt-2"><strong>2.1 Information You Provide</strong><br>
              <div class="mt-2" style="font-weight: normal;">When you register for or use the Portal, you may provide personal information, including but not limited to: full name, date of birth, email address, telephone number, mailing address, educator license or application numbers, education and employment history, supporting documents (such as scanned licenses or transcripts), and payment information where applicable.</div>
            </div>
            <div class="mt-2"><strong>2.2 Device, Technical, and Usage Information</strong><br>
              <div class="mt-2" style="font-weight: normal;">To protect accounts and monitor Portal operations, NV DOE collects technical and usage data automatically, such as device type and operating system, browser type and version, Internet Protocol (IP) address, approximate geolocation, device identifiers, cookies and similar technologies, login timestamps, session duration, and activity logs.</div>
            </div>
            <div class="mt-2"><strong>2.3 Communications Records</strong><br>
              <div class="mt-2" style="font-weight: normal;">We maintain records of communications you receive from NV DOE through the Portal, email, or SMS, and correspondence you exchange with NV DOE staff or support teams.</div>
            </div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>How We Use Information</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE uses collected information for legitimate operational purposes, including to:</div>
            <ul style="list-style-type: disc; color: #111; margin-left: 2em;">
              <li style="color: #111; font-weight: normal;">Process and manage licensure applications and renewals.</li>
              <li style="color: #111; font-weight: normal;">Verify account ownership and provide multi-factor authentication.</li>
              <li style="color: #111; font-weight: normal;">Detect, investigate, and prevent fraud or unauthorized access.</li>
              <li style="color: #111; font-weight: normal;">Communicate about application status, account issues, system changes, legal notices, and to improve user experience and customer support.</li>
              <li style="color: #111; font-weight: normal;">Perform system maintenance, security monitoring, and analytics to improve service delivery.</li>
              <li style="color: #111; font-weight: normal;">Fulfill legal obligations and respond to lawful requests from government agencies or courts.</li>
            </ul>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Legal Basis and Applicable Laws</strong><br>
            <div class="mt-2" style="font-weight: normal;">Processing of education records and certain personal information is governed by federal law, including the Family Educational Rights and Privacy Act (FERPA), and by Nevada state statutes and information security policies. NV DOE processes personal information under the authority granted by applicable state law and federal regulations necessary to administer licensure programs and fulfill official functions.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Sharing and Disclosure</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE does not sell or rent your personal information to third parties. We may share your information only under limited circumstances, such as:</div>
            <ul style="list-style-type: disc; color: #111; margin-left: 2em;">
              <li style="color: #111; font-weight: normal;">With NV DOE staff and authorized contractors who require access to perform official duties. These parties are bound by strict confidentiality and data protection agreements.</li>
              <li style="color: #111; font-weight: normal;">With other state or federal agencies when required by law or for official purposes.</li>
              <li style="color: #111; font-weight: normal;">With vendors who provide services for the Portal (for example, hosting providers, identity verification, messaging vendors); such vendors are contractually required to protect the data.</li>
              <li style="color: #111; font-weight: normal;">In response to subpoenas, court orders, or other legal processes.</li>
              <li style="color: #111; font-weight: normal;">To protect the rights, property, or safety of NV DOE, Portal users, or the public.</li>
            </ul>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Data Retention</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE retains personal information as long as necessary to fulfill the purposes described in this Privacy Policy, comply with legal obligations, resolve disputes, and enforce agreements. Retention periods may vary by data type and legal requirements; records related to licensing and certification will be retained in accordance with Nevada recordkeeping laws.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Security Measures</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE employs administrative, technical, and physical safeguards designed to protect information from unauthorized access, disclosure, alteration, or destruction. Safeguards include access controls, encryption for data in transit and at rest where appropriate, audit logging, and security monitoring. While NV DOE uses commercially reasonable measures, no system is completely secure. Users are encouraged to protect their account credentials and promptly report suspected unauthorized access.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Cookies and Tracking Technologies</strong><br>
            <div class="mt-2" style="font-weight: normal;">The Portal uses cookies and similar technologies to manage sessions, provide security features, and collect analytics about Portal usage. You may set your browser to block or delete cookies, but blocking cookies may reduce Portal functionality. Where applicable, you can manage cookie preferences through the Portal.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Communications and Consent</strong><br>
            <div class="mt-2" style="font-weight: normal;">By registering for the Portal and selecting required communications consent, you expressly consent to receive electronic communications from NV DOE, including emails and SMS messages for account verification, status updates, security alerts, and other official notices. Standard message and data rates from your mobile carrier may apply. Some communications required for account operation cannot be opted out of. You may update your communication preferences through your account settings for optional messages.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Your Rights and Choices</strong><br>
            <div class="mt-2" style="font-weight: normal;">Where permitted by law, you may:</div>
            <ul style="list-style-type: disc; color: #111; margin-left: 2em;">
              <li style="color: #111; font-weight: normal;">Access, review, or request a copy of personal information held by NV DOE.</li>
              <li style="color: #111; font-weight: normal;">Request correction of inaccurate personal information.</li>
              <li style="color: #111; font-weight: normal;">Update your contact and account preferences in the Portal.</li>
              <li style="color: #111; font-weight: normal;">Withdraw consent for non-essential electronic communications; withdrawal may limit Portal functionality.</li>
              <li style="color: #111; font-weight: normal;">Request deletion of personal information where allowed by applicable law and recordkeeping obligations.</li>
            </ul>
            <div class="mt-2" style="font-weight: normal;">To exercise these rights, please contact NV DOE using the information below.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Third-Party Links and Services</strong><br>
            <div class="mt-2" style="font-weight: normal;">The Portal may contain links to third-party websites or use third-party services. This Privacy Policy does not apply to third-party sites or services. NV DOE is not responsible for the privacy practices or content of third parties.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Children's Privacy</strong><br>
            <div class="mt-2" style="font-weight: normal;">The Portal is not intended for use by children under the age of 13. NV DOE does not knowingly collect personal information from children under 13 through the Portal.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Changes to This Privacy Policy</strong><br>
            <div class="mt-2" style="font-weight: normal;">NV DOE may update this Privacy Policy. We will post the revised policy on the Portal, update the "Last Updated" date, and notify users of significant changes through the Portal or email. Continued use of the Portal after changes are posted constitutes acceptance of the updated Privacy Policy.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Governing Law</strong><br>
            <div class="mt-2" style="font-weight: normal;">This Privacy Policy is governed by the laws of the State of Nevada and applicable federal laws of the United States.</div>
          </li>
          <li class="mt-3" style="font-weight: bold;"><strong>Contact Information</strong><br>
            <div class="mt-2" style="font-weight: normal;">For questions about this Privacy Policy, to exercise your rights, or to report a privacy concern, contact:<br>
            Nevada Department of Education<br>
            Las Vegas Office<br>
            2080 E. Flamingo Road<br>
            Las Vegas, NV 89119<br>
            P 702.486.6458</div>
          </li>
        </ol>
      </div>
    </div>
  `,
  activateExam:  `<p>Are you sure you want to activate this exam?</p><p>Once activated, this exam will be available as an option in Nevada Testing for ALL active applications.</p>`,
  deactivateExam:  `<p>Are you sure you want to deactivate this exam?</p><p>Once deactivated, this exam will no longer be available as an option in Nevada Testing for NEW applications.</p>`,
  applicationAlreadySubmitted: `<p>You may have only one application in process at a time.<br>
            Since you have already submitted an application, you must wait until it is completed (approved, denied, or
            archived) before starting a new one.</p>`,

            useragreement: `
<div style="max-width:800px;margin:20px auto;font-family:'Times New Roman', Times, serif;font-size:13.5px;line-height:1.55;color:#000;">

    <!-- HEADER -->
            <h3 class="mb-4 text-center"><strong> Nevada Department of Education (NDE) OPAL<br>
        Local Education Agency (LEA) User Agreement</strong></h3>

    <!-- INTRO -->
    <p style="text-align:justify;">
        By creating an account and using the Nevada Department of Education (“Department”) Online Portal for Applications and Licensure (“OPAL”), you agree to comply with and be bound by the following terms and conditions of use as an Authorized User and/or Administrative User of a Local Education Agency (“LEA”) which, together with the Department’s <a href="https://doe.nv.gov/privacy-policy" target="_blank" class="info-link">Privacy Policy</a>, govern the Department's relationship with you in regard to OPAL.If you disagree with any part of these terms and conditions, please do not use OPAL and contact the Nevada Office of Educator Licensure at license@doe.nv.gov or (702) 486-6458.
    </p>

    
    
    <!-- SECTION 1 -->
    <h5 class="mb-3">
        <strong>1. Authorized User Responsibilities.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You warrant that the LEA you are employed by or otherwise represent has given you the authority to conduct the business of the LEA on OPAL on its behalf. If such authority is revoked, you agree to notify the Department immediately upon revocation.
    </p>
    <p class="mb-0 ml-3">
        <strong>b.</strong> You must have your own unique login; sharing accounts is prohibited.
    </p>
    <p class="mb-0 ml-3">
        <strong>c.</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You must change your login credentials immediately and notify the Department if you suspect unauthorized access to your account.
    </p>

<p class="mb-0 ml-3">
        <strong>d.</strong> You will not use OPAL for any purpose beyond its intended purpose. Unauthorized use of OPAL may result in your removal from OPAL and may give rise to a claim for damages and/or be a criminal offense.
  </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> You will adhere to all instructions provided for each template and upload, ensuring that data is accurately submitted.
  </p>
  
    <!-- SECTION 2 -->
    <h5 class="mb-2 mt-3">
        <strong>2. If your role is as an Administrative User, you agree to the additional Administrative Responsibilities.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You warrant that the LEA you represent has given you the authority to create, approve, and deactivate user accounts in the Portal and otherwise conduct the business of the LEA on the Portal. If such authority is revoked, you agree to notify the Department immediately upon revocation.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> You agree to create or approve user accounts in OPAL only for those whom the LEA has identified as authorized to access OPAL and conduct the business of the LEA on OPAL. Granting unauthorized access may result in termination of OPAL access and may give rise to a claim for damages and/or be a criminal offense.
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> You must have your own unique login; sharing accounts is prohibited.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You must change your login credentials immediately and notify the Department if you suspect unauthorized access to your account.
    </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> You will not use OPAL for any purpose beyond its intended purpose. Unauthorized use of OPAL may give rise to a claim for damages and/or be a criminal offense.
    </p>

    <p class="mb-0 ml-3">
        <strong>f.</strong> If you suspect the OPAL login credentials of any user for the LEA have been compromised, you will immediately notify the affected user and direct them to change their credentials and notify the Department.
    </p>

    <p class="mb-0 ml-3">
        <strong>g.</strong> If a user leaves employment with the LEA or no longer requires access to the Portal, you will deactivate their access to the Portal within seven (7) business days of the last day of employment or the date access is no longer necessary and provide notice of the deactivation of the user to the Department via email to license@doe.nv.gov.
    </p>

    <!-- SECTION 3 -->
    <h5 class="mb-2 mt-3">
        <strong>3. Data Collection & Protection.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> The Department’s Privacy Policy sets out how the Department uses and protects any information that you give the Department when you use OPAL.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> The Department collects and processes personal and technical information in accordance with NRS 391.035 to protect users and ensure proper operation of OPAL. This includes data you provide directly (such as name, contact details) and technical information collected automatically (such as device type, browser, IP address, login timestamps).
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> The information, records, and data you provide in OPAL is used solely for security and operational purposes and is not shared with third parties except as required by law or as necessary to facilitate educator licensure processes. As consistent with confidentiality rules, information and records inputted, uploaded, or otherwise housed in OPAL may be disclosed by the Department in response to a public records request pursuant to NRS Chapter 239 or an administrative or judicial subpoena, search warrant, or other order. The Department does not have an obligation to notify you.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> OPAL contains material which is owned by or licensed to the Department. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited.
    </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> References on this website to names, trademarks, products or services of any third party or links to third party sites are provided solely as a convenience to you and do not constitute or imply endorsement or sponsorship. The Department is not responsible for any damage or loss incurred.
    </p>

    <p class="mb-0 ml-3" >
        <strong>f.</strong> Information on your use of OPAL may be collected and retained to improve functionality.
    </p>

    <p class="mb-0 ml-3">
        <strong>g.</strong> You agree not to interfere, disrupt, or attempt to interfere or disrupt OPAL using any device, software, or routine.
    </p>

    <!-- SECTION 4 -->
    <h5 class="mb-2 mt-3" >
        <strong>4. Miscellaneous.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You consent to receive emails, SMS text messages (standard message and data rates from your mobile carrier may apply), and other electronic communications from the Department.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> The terms and conditions for use of OPAL may change. When you access OPAL, you will be bound by the most recent terms.
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> The Department reserves the right to terminate or suspend access for any violations.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> Any dispute arising from use of OPAL will be resolved according to Nevada law.
    </p>

</div>`,

useragreementfp : `
  <div style="max-width:800px;margin:20px auto;font-family:'Times New Roman', Times, serif;font-size:13.5px;line-height:1.55;color:#000;">

 <!-- HEADER -->
            <h3 class="mb-4 text-center"><strong> Nevada Department of Education (NDE) OPAL
Fingerprinting Vendor User Agreement</strong></h3>

 <p style="text-align:justify;">
        By creating an account and using the Nevada Department of Education (“Department”) Online Portal for Applications and Licensure (“OPAL”), you agree to comply with and be bound by the following terms and conditions of use as an Authorized User and/or Administrative User of a fingerprinting vendor (“Vendor”) which, together with the Department’s <a href="https://doe.nv.gov/privacy-policy" target="_blank" class="info-link">Privacy Policy</a>, govern the Department's relationship with you in regard to OPAL. If you disagree with any part of these terms and conditions, please do not use OPAL and contact the Nevada Office of Educator Licensure at license@doe.nv.gov or (702) 486-6458.
    </p>

    <h5 class="mb-3">
        <strong>1. Authorized User Responsibilities.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You warrant that the Vendor you are employed by and otherwise represent has given you the authority to conduct the business of the Vendor on OPAL on its behalf. If such authority is revoked, you agree to notify the Department immediately upon revocation.
    </p>
    <p class="mb-0 ml-3">
        <strong>b.</strong> You must have your own unique login; sharing accounts is prohibited.
    </p>
    <p class="mb-0 ml-3">
        <strong>c.</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You must change your login credentials immediately and notify the Department if you suspect unauthorized access to your account.
    </p>

<p class="mb-0 ml-3">
        <strong>d.</strong> You will not use OPAL for any purpose beyond the purpose of processing applicant fingerprints using the procedure outlined herein. Unauthorized use of OPAL may result in the Vendor’s removal from the approved vendor list, your removal from OPAL, and may give rise to a claim for damages and/or be a criminal offense.
  </p>

    <!-- SECTION 2 -->
    <h5 class="mb-2 mt-3">
        <strong>2. Administrative User Responsibilities (as applicable).</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You warrant that the Vendor you are employed by and otherwise represent has given you the authority to conduct the business of the Vendor on OPAL on its behalf. If such authority is revoked, you agree to notify the Department immediately upon revocation.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> You agree to create or approve user accounts in OPAL only for those whom the Vendor has identified as authorized to access OPAL and conduct the business of the Vendor on OPAL. Granting unauthorized access may result in termination of OPAL access and may give rise to a claim for damages and/or be a criminal offense.
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> You must have your own unique login; sharing accounts is prohibited.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You must change your login credentials immediately and notify the Department if you suspect unauthorized access to your account.
    </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> You will not use OPAL for any purpose beyond the purpose of processing applicant fingerprints using the procedure outlined herein. Unauthorized use of OPAL may result in the Vendor’s removal from the approved vendor list, your removal from OPAL, and may give rise to a claim for damages and/or be a criminal offense.
    </p>

    <p class="mb-0 ml-3">
        <strong>f.</strong> If you suspect the OPAL login credentials of the Vendor or any user for the Vendor have been compromised, you will immediately notify the affected user and direct them to change their credentials and notify the Department.
    </p>

    <p class="mb-0 ml-3">
        <strong>g.</strong> If a user leaves employment with the Vendor or no longer requires access to the Portal, you will deactivate their access to the Portal within seven (7) business days of the last day of employment or the date access is no longer necessary and provide notice of the deactivation of the user to the Department via email to license@doe.nv.gov.
    </p>

     <p class="mb-0 ml-3">
        <strong>h.</strong> Vendor must remain on the Nevada State Police approved private fingerprint vendor list. If removed, you must notify the Department in writing within two (2) business days, and fingerprint submissions must immediately cease until reinstated.
    </p>

    <p class="mb-0 ml-3">
        <strong>i.</strong> You must notify the Department within two (2) business days regarding any changes to business location or phone numbers.
    </p>


     <!-- SECTION 3 -->
     <h5 class="mb-2 mt-3">
        <strong>3. Training & Procedure.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You agree to be trained by a Department representative (in person or via video/phone) on fingerprinting procedures prior to processing any applicant fingerprints.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> You agree to adhere to the following fingerprinting procedure and any subsequent updates, templates, or instructions provided to you in writing by the Department:
    </p>


    <p class="mb-0 ml-5">
        <span> i.</span> Identity Verification: Verify the applicant's identity using a government-issued photo ID.
    </p>

    <p class="mb-0 ml-5">
        <span> ii.</span> Application Verification: Confirm an active application exists in the OPAL portal before submitting Livescan fingerprints.
    </p>

    <p class="mb-0 ml-5 pl-3">
        Note: If no application exists, use an FD-258 fingerprint card instead.
    </p>

    <p class="mb-0 ml-5">
        <span> iii.</span> Data Entry: Immediately enter the submission date and the Transaction Control Number (TCN) (from Nevada State Police Records, Communications and Compliance Division) into the OPAL portal after fingerprinting.
    </p>

    <!-- SECTION 4 -->
    <h5 class="mb-2 mt-3" >
        <strong>4. Data Collection & Protection.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> The Department’s Privacy Policy sets out how the Department uses and protects any information that you give the Department when you use OPAL.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> The Department collects and processes personal and technical information in accordance with NRS 391.035 to protect users and ensure proper operation of OPAL. This includes data you provide directly, and technical information collected automatically (such as device type, browser, IP address, login timestamps).
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> The information, records, and data you provide in OPAL is used solely for security and operational purposes and is not shared with third parties except as required by law or as necessary to facilitate educator licensure processes. As consistent with confidentiality rules, information and records inputted, uploaded, or otherwise housed in OPAL may be disclosed by the Department in response to a public records request pursuant to NRS Chapter 239 or an administrative or judicial subpoena, search warrant, or other order. The Department does not have an obligation to notify you of a public records request, subpoena, search warrant, or other order.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> OPAL contains material which is owned by or licensed to the Department. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited.
    </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> References on this website to names, trademarks, products or services of any third party or links to third party sites are provided solely as a convenience to you and do not constitute or imply an endorsement or sponsorship by the Department or an affiliation with the third party. You agree that the Department will not be responsible for any damage or loss incurred in connection with the third-party websites or any products or services available from the third party.
    </p>

    <p class="mb-0 ml-3">
        <strong>f.</strong> Information or data on your use of OPAL may be collected and retained by the Department and may be used by the Department to maintain or improve upon or otherwise assist in the functioning of OPAL.
    </p>

    <p class="mb-0 ml-3">
        <strong>g.</strong> You agree not to interfere, disrupt, or attempt to interfere or disrupt OPAL using any device, software, or routine.
    </p>

    <!-- SECTION-5 -->
    <h5 class="mb-2 mt-3" >
        <strong>5. Miscellaneous.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> No contract exists between the Department and Vendor, its Authorized Users or Administrative Users.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong>You consent to receive emails, SMS text messages (standard message and data rates from your mobile carrier may apply), and other electronic communications from the Department for purposes including, but not limited to account verification, security notifications, official updates regarding your licensure.
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> The terms and conditions for use of OPAL may change. When you access OPAL, you will be bound by the most recent terms and conditions.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> Either party may terminate the professional relationship at any time, with or without cause, via written notice. 
    </p>

     <p class="mb-0 ml-3">
        <strong>e.</strong> Any dispute arising from use of OPAL will be resolved according to Nevada law.
    </p>

</div>
`,
 useragreementepp: `<div style="max-width:800px;margin:20px auto;font-family:'Times New Roman', Times, serif;font-size:13.5px;line-height:1.55;color:#000;">

    <!-- HEADER -->
            <h3 class="mb-4 text-center"><strong> Nevada Department of Education (NDE) OPAL
Education Program Provider (EPP) User Agreement</strong></h3>

    <!-- INTRO -->
    <p style="text-align:justify;">
        By creating an account and using the Nevada Department of Education (“Department”) Online Portal for Applications and Licensure (“OPAL”), you agree to comply with and be bound by the following terms and conditions of use as an Authorized User and/or Administrative User of an Education Program Provider (“EPP”) which, together with the Department’s <a href="https://doe.nv.gov/privacy-policy" target="_blank" class="info-link">Privacy Policy</a>, govern the Department's relationship with you in regard to OPAL. If you disagree with any part of these terms and conditions, please do not use OPAL and contact the Nevada Office of Educator Licensure at license@doe.nv.gov or (702) 486-6458.
    </p>

    
    
    <!-- SECTION 1 -->
    <h5 class="mb-3">
        <strong>1. Authorized User Responsibilities.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You warrant that the EPP you are employed by or otherwise represent has given you the authority to conduct the business of the EPP on OPAL on their behalf. If such authority is revoked, you agree to notify the Department immediately upon revocation.
    </p>
    <p class="mb-0 ml-3">
        <strong>b.</strong> You must have your own unique login; sharing accounts is prohibited.
    </p>
    <p class="mb-0 ml-3">
        <strong>c.</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You must change your login credentials immediately and notify the Department if you suspect unauthorized access to your account.
    </p>

<p class="mb-0 ml-3">
        <strong>d.</strong> You will not use OPAL for any purpose beyond its intended purpose. Unauthorized use of OPAL may result in your removal from OPAL and may give rise to a claim for damages and/or be a criminal offense.
  </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> You will adhere to all instructions provided for each template and upload, ensuring that data is accurately submitted.
  </p>
  
    <!-- SECTION 2 -->
    <h5 class="mb-2 mt-3">
        <strong>2. If your role is as an Administrative User, you agree to the additional Administrative Responsibilities.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You warrant that the EPP you represent has given you the authority to create, approve, and deactivate user accounts in OPAL and otherwise conduct the business of the EPP on OPAL. If such authority is revoked, you agree to notify the Department immediately upon revocation.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> You agree to create or approve user accounts in OPAL only for those whom the EPP has identified as authorized to access OPAL and conduct the business of the EPP on OPAL. Granting unauthorized access may result in termination of OPAL access and may give rise to a claim for damages and/or be a criminal offense.
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> You must have your own unique login; sharing accounts is prohibited.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You must change your login credentials immediately and notify the Department if you suspect unauthorized access to your account.
    </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> You will not use OPAL for any purpose beyond its intended purpose. Unauthorized use of OPAL may give rise to a claim for damages and/or be a criminal offense.
    </p>

    <p class="mb-0 ml-3">
        <strong>f.</strong> If you suspect the OPAL login credentials of any user for the EPP have been compromised, you will immediately notify the affected user and direct them to change their credentials and notify the Department.
    </p>

    <p class="mb-0 ml-3">
        <strong>g.</strong> If a user leaves employment with the EPP or no longer requires access to OPAL, you will deactivate their access to OPAL within seven (7) business days of the last day of employment or the date access is no longer necessary and provide notice of the deactivation of the user to the Department via email to license@doe.nv.gov.
    </p>

    <!-- SECTION 3 -->
    <h5 class="mb-2 mt-3">
        <strong>3. Data Collection & Protection.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> The Department’s Privacy Policy sets out how the Department uses and protects any information that you give the Department when you use OPAL.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> The Department collects and processes personal and technical information in accordance with NRS 391.035 to protect users and ensure proper operation of OPAL. This includes data you provide directly (such as name, contact details) and technical information collected automatically (such as device type, browser, IP address, login timestamps).
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> The information, records, and data you provide in OPAL is used solely for security and operational purposes and is not shared with third parties except as required by law or as necessary to facilitate educator licensure processes. As consistent with confidentiality rules, information and records inputted, uploaded, or otherwise housed in OPAL may be disclosed by the Department in response to a public records request pursuant to NRS Chapter 239 or an administrative or judicial subpoena, search warrant, or other order. The Department does not have an obligation to notify you.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> OPAL contains material which is owned by or licensed to the Department. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited.
    </p>

    <p class="mb-0 ml-3">
        <strong>e.</strong> References on this website to names, trademarks, products or services of any third party or links to third party sites are provided solely as a convenience to you and do not constitute or imply endorsement or sponsorship. The Department is not responsible for any damage or loss incurred.
    </p>

    <p class="mb-0 ml-3" >
        <strong>f.</strong> Information on your use of OPAL may be collected and retained to improve functionality.
    </p>

    <p class="mb-0 ml-3">
        <strong>g.</strong> You agree not to interfere, disrupt, or attempt to interfere or disrupt OPAL using any device, software, or routine.
    </p>

    <!-- SECTION 4 -->
    <h5 class="mb-2 mt-3" >
        <strong>4. Miscellaneous.</strong>
    </h5>

    <p class="mb-0 ml-3">
        <strong>a.</strong> You consent to receive emails, SMS text messages (standard message and data rates from your mobile carrier may apply), and other electronic communications from the Department.
    </p>

    <p class="mb-0 ml-3">
        <strong>b.</strong> The terms and conditions for use of OPAL may change. When you access OPAL, you will be bound by the most recent terms.
    </p>

    <p class="mb-0 ml-3">
        <strong>c.</strong> The Department reserves the right to terminate or suspend access for any violations.
    </p>

    <p class="mb-0 ml-3">
        <strong>d.</strong> Any dispute arising from use of OPAL will be resolved according to Nevada law.
    </p>

</div>`,
  accountMayExist: (name: string, email: string, phone: string, ssn: string) => `
            <p>An account with similar information appears to already exist. This may be a duplicate registration. Please review the details below:</p>
            <div><strong>Name:</strong> ${name}</div>
            <div><strong>Email:</strong> ${email}</div>
            <div><strong>Phone:</strong> ${phone}</div>
            <div><strong>SSN:</strong> ${ssn}</div>
            <div class="mt-3">Please review the information you entered, or log out and use the Forgot Email option to recover your existing account.</div>
            `,
  /** Lookup staff: duplicate SSN on Identity update (educator context, single dismiss action). */
  accountMayExistLookupEducator: (name: string, email: string, phone: string, ssn: string) => `
            <p>An account with similar information already exists in the system. This may indicate a duplicate registration. Please verify the educator's details and confirm the correct information before proceeding.</p>
            <div><strong>Name:</strong> ${name}</div>
            <div><strong>Email:</strong> ${email}</div>
            <div><strong>Phone:</strong> ${phone}</div>
            <div><strong>SSN:</strong> ${ssn}</div>
            <div class="mt-3">The updated SSN has not been saved. Please review the information entered and confirm the correct details with the educator before proceeding.</div>
            `,
  fingerPrintSubmission : `<p>You are about to submit this fingerprint record for the educator listed below. Please make sure the information is correct.</p>`,
  licenseContent: (
    formattedDate: string,
    licenseFee: number,
    licenseKinds: string,
    endorsements: string,
    provisions: string,
    licenseRequirements: string
  ) => {
    const nonEligibleItems = [licenseKinds, endorsements, provisions, licenseRequirements]
      .map((item: string) => String(item || '').trim())
      .filter((item: string) => item.length > 0)
      .map((item: string) => `<strong class="text-danger">${item}</strong>`)
      .map((item: string) => `<strong class="text-danger">${item}</strong>`)
      .join(', ');
    const hasNonEligibleItems = nonEligibleItems.length > 0;

    return `
      <p class='mb-0'>A license extension is available once per licensure period.</p>
      ${hasNonEligibleItems? `<p class='mb-3'>Please review the extension eligibility carefully, as you currently have ${nonEligibleItems} <strong class="text-danger licensename" style='font-weight: 800;'>that are not eligible for extension.</strong> You can review the eligibility status in the License Details and License Requirements sections of your dashboard.</p>
      <p class='mb-3'>If you proceed, only the license kinds, endorsements, provisions, and license requirements that are currently eligible for extension will have their expiration or due dates extended. Items that are not eligible will not be extended.</p>`: ''}
      <p class='mb-3'>A <strong>$${licenseFee}</strong> license extension fee will be added to your <strong>next application</strong> if you choose to proceed.</p>
      <p class='mb-0'>To confirm, please type your full legal name exactly as it appears on your license. By doing so, you acknowledge that you understand the extension fee and authorize the updates described above.</p>
    `;
  },
  educatorLicenseContent: (
    formattedDate: string,
    licenseFee: number,
    licenseKinds: string,
    endorsements: string,
    provisions: string,
    licenseRequirements: string
  ) => {
    const nonEligibleItems = [licenseKinds, endorsements, provisions, licenseRequirements]
      .map((item: string) => String(item || '').trim())
      .filter((item: string) => item.length > 0)
      .map((item: string) => `<strong class="text-danger">${item}</strong>`)
      .map((item: string) => `<strong class="text-danger">${item}</strong>`)
      .join(', ');
    const hasNonEligibleItems = nonEligibleItems.length > 0;

    return `
      <p class='mb-0'>A license extension is available once per licensure period.</p>
      ${hasNonEligibleItems? `<p class='mb-3'>Please review the extension eligibility carefully, as the educator currently has ${nonEligibleItems} <strong class="text-danger licensename" style='font-weight: 800;'>that are not eligible for extension.</strong>. You can review the eligibility status in the License Details and License Requirements sections of the educator’s profile.</p>
      <p class='mb-3'>If you proceed, only the license kinds, endorsements, provisions, and license requirements that are currently eligible for extension will have their expiration or due dates extended. Items that are not eligible will not be extended.</p>`: ''}
      <p class='mb-3'>A <strong>$${licenseFee}</strong> license extension fee will be added to the educator’s <strong>next application</strong> if the extension is completed.</p>
      <p class='mb-0'>By completing this action, you confirm that the license extension is being processed by staff on behalf of the educator and that you understand the extension fee associated with this action.</p>
    `;
  },
  userActivityLogContent:(field_name: string, newVal: string, oldVal: string) => {
    if( newVal === null ||  newVal === undefined) newVal= ' ';
    if( oldVal === null ||  oldVal === undefined) oldVal= ' ';

    return `<table class="table table-bordered table-view-user-logs" ">
      <thead>
        <tr>
          <th>Field Name</th>
          <th>Old Value</th>
          <th>New Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${field_name}</td>
          <td>${oldVal}</td>
          <td>${newVal}</td>
        </tr>
      </tbody>
    </table>`
    },
  reverseExtnContent: `<p  style="font-size: 1.2em !important;"> Are you sure you want to reverse all active extensions for this license?This will restore the previous effective and expiration dates for any license kinds, Endorsements, Provisions and License Requirementss that were extended.</p>`,

  /** Staff upload notice body (default): same copy as former `ng-template` / Ngb modals. */
  staffDocumentUploadNoticeDefault: `<div class="lookup-staff-upload-warning d-flex align-items-start rounded p-3"><span class="material-symbols-outlined">warning</span><p class="mb-0">Documents uploaded by staff are automatically marked as <strong>Verified</strong>. Please ensure the document has been reviewed and confirmed as valid before proceeding.</p></div>`,

  /** Communication tab variant. */
  staffDocumentUploadNoticeCommunication: `<div class="lookup-staff-upload-warning d-flex align-items-start rounded p-3"><span class="material-symbols-outlined">warning</span><p class="mb-0"> Documents uploaded by staff are automatically marked as <strong>Verified</strong>. Please ensure the document has been reviewed and confirmed as valid before proceeding.</p></div>`,

  educatorDuplicateDocumentBody: `<p class="mb-0">A document with the same Category and Filename already exists. You can check your file or proceed with uploading.</p>`,
});
export const modalButtonTitles = Object.freeze({
  cancel: "Cancel",
  assign: "Assign",
  unassign: "Unassign",
  viewApplication: "View Application",
  close:"Close",
  activate: "Activate",
  deactivate: "Deactivate",
  ok: "OK",
  inactive : "Inactive",
  active: "Active",
  confirm: "Confirm",
  returnToForm: "Return to Form",
  returnToProfile: "Return to profile",
  logOutAndForgotEmail: "Forgot Email",
  completeRegistration: "Complete Registration",
  extend: "Extend",
  viewCase: "View case",
  proceed: "Proceed",
  userlogsclose: "Close",
});

export const errorMessages = {
  invalidDate : 'Invalid date entered. Max allowed is 12/31/9999.',
  dateExceed : 'Date exceeds max allowed (12/31/9999).',
  failedPersons: 'Failed to load persons by role. Please try again later.',
  noValidUser : 'No valid user ID found in session storage',
  noActiveVersionId : 'No activeversionid found in app data',
  unassignMsg : 'Failed to unassign application. Please try again later.',
  assignMsg : 'Failed to assign application. Please try again later.',
  tempLockMsg : 'Failed to temp lock application. Please try again later.',
  fetchQueueData : 'Failed to fetch queue data. Please try again later.',
  examActive : 'Exam activated successfully.',
  examDeactive : 'Exam deactivated successfully.',
  examUpdate : 'Exam status updated successfully.',
  savedSuccess : 'Saved successfully.',
  addedSuccess : 'Added successfully.',
  saveBusiness : 'Failed to save business rule',
  selectEffEndDate:'Please select an effective end date.',
  validValue:'Please enter a valid value',
  validDate:'Please enter a valid Date',
  selectEffStartDate:'Please select an effective start date.',
  invalidMonth: 'Please enter a valid Month',
  invalidDay: 'Please enter a valid Date',
  searchNotFound : 'No matching educator found or the educator does not currently require new fingerprints.',
  submitSuccess : 'Submitted Successfully.'
}

export interface AssignmentSessionData {
  youthID: string | number;
  youthNumber?: string | number;
  applicationID: string | number;
  isFirstSave: boolean | string;
  applicationType?: string;
  currApplicationType?: string;
  backToHome: { name: string };
  backToGridPage: { name: string };
  applicationTotalFee?: number | string;
  applicationFee?: number | string;
  backButtonText?: string;
}

export const toastMessage = Object.freeze({ 
  'G0036' : 'This test is active. Adding an End Date will automatically deactivate it.',
  'G0037' : 'This test is inactive. Removing the End Date will automatically activate it.',
});


